
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.277 15.856h-7.552a.6.6 0 00-.6.599.6.6 0 00.184.429l5.317 5.317a.6.6 0 00.938-.073 9.55 9.55 0 002.3-5.566.461.461 0 00.012-.107.599.599 0 00-.6-.599zM15.444 5a.6.6 0 00-.597.599v8.393c0 .332.267.6.597.6h8.395a.6.6 0 00.6-.6A9.61 9.61 0 0015.443 5z","fill":"#fff","fill-opacity":".65"}}),_c('path',{attrs:{"d":"M20.058 21.712l-6.192-6.193a.597.597 0 01-.168-.418l-.003-8.746a.597.597 0 00-.596-.597 9.61 9.61 0 00-9.013 9.591c0 5.307 4.302 9.612 9.61 9.612a9.571 9.571 0 006.322-2.373.6.6 0 00.04-.876z","fill":"#fff"}})])
          )
        }
      }
    